import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c410606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-container" }
const _hoisted_2 = { class: "report-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Errors Log", -1))
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { class: "error-details" }
const _hoisted_7 = { class: "error-details-section" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Stack Trace", -1))
const _hoisted_9 = {
  key: 0,
  class: "error-details-section"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      dataKey: "id",
      class: "report-datatable",
      scrollHeight: "flex",
      stripedRows: "",
      expandedRows: _ctx.expandedRows,
      "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedRows) = $event)),
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50, 100],
      scrollable: true,
      value: _ctx.items,
      paginator: true,
      rows: 25,
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
      loading: _ctx.loading,
      globalFilterFields: _ctx.globalFilter,
      filterDisplay: "row"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
              placeholder: "Keyword Search"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("No error log entries found.")
      ]),
      loading: _withCtx(() => [
        _createTextVNode("Loading errors log. Please wait.")
      ]),
      expansion: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("pre", null, _toDisplayString(data.trace || 'No trace available.'), 1)
          ]),
          (data.data)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("pre", null, _toDisplayString(data.data), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          expander: true,
          headerStyle: "width: 3rem"
        }),
        _createVNode(_component_Column, {
          field: "createTime",
          header: "Date",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(data.createTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "controller",
          header: "Controller",
          sortable: true,
          style: {"min-width":"12rem"}
        }),
        _createVNode(_component_Column, {
          field: "type",
          header: "Type",
          sortable: true,
          style: {"min-width":"12rem"}
        }),
        _createVNode(_component_Column, {
          field: "message",
          header: "Message",
          sortable: true,
          style: {"min-width":"18rem"}
        }),
        _createVNode(_component_Column, {
          field: "originAccount",
          header: "Account",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.originAccount || (data.originAccountId ? '#' + data.originAccountId : '-')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["expandedRows", "value", "filters", "loading", "globalFilterFields"])
  ]))
}